module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_her2st.4e68312b.png";